import React, { useState, useEffect } from 'react'
import { Baseurl } from '../constants/env'
import axios from 'axios'
import QuillTextDisplay from './common/QuillTextDisplay'

const Tempfooter = (props) => {
   const [footerdata,setFooterdata] = useState([])
  const getfooter = async () => {
    let res = await axios(`${Baseurl}/footer`)
    console.log(res,'res')
    if(res) setFooterdata(res?.data?.[0])
    if(props.phoneNumber){
      props.phoneNumber(res?.data?.[0]?.whatsappNumber)
    }
  } 
useEffect(() => {
  (async () => {
await getfooter()
  })()
},[])
  return (
    <>
    <footer>




<div class="footer-bottom">
  <div class="container">



    <div class="row">
      <div class="col-md-4">

        <img class="mb-3 w-25 h-25" src={`${Baseurl}/view/imageupload/${footerdata.img}`} />
        <div class="w-75">
          <p> <QuillTextDisplay text={footerdata.description} /> </p>
        </div>
        <div class=" social">

          <a href={footerdata.facebook} target="_blank"> <i class="bi bi-facebook"></i></a>
          <a href={footerdata.instagram} target="_blank" > <i class="bi bi-instagram"></i></a>
          <a href={footerdata.youtube}  target="_blank"> <i class="bi bi-youtube"></i></a>

        </div>
      </div>


      <div class="col-md-4">

        <h5>Services</h5>

        <div class="footer-links">
          <ul>
            <li> <a href="#">Terms</a> </li>
            <li> <a href="#">Privacy</a> </li>
            <li> <a href="#">Cookies</a> </li>
          </ul>
        </div>

      </div>

      <div class="col-md-2">

        <h5>Quick Links</h5>

        <div class="footer-links">
          <ul>
            <li> <a href="#">Terms</a> </li>
            <li> <a href="#">Privacy</a> </li>
            <li> <a href="#">Cookies</a> </li>
          </ul>
        </div>

      </div>
      <div class="col-md-2">

        <h5>Quick Links</h5>

        <div class="footer-links">
          <ul>
            <li> <a href="#">Terms</a> </li>
            <li> <a href="#">Privacy</a> </li>
            <li> <a href="#">Cookies</a> </li>
          </ul>
        </div>

      </div>



      <div class="col-md-4 footer-links">

      </div>

    </div>




  </div>

</div>
<div class="copyright">

  <div class="container">
    <div class="row">
      <div class="col-md-6 d-flex align-items-center">
        <p>© imox All Rights Reserved</p>
      </div>

      <div class="col-md-6">

        <div class="d-flex align-items-center">

          <p class="me-3 mb-0">Accept Cards</p>
          <img src="assets/images/home/accept-cards.png" />
        </div>
     
      </div>
    </div>
  </div>
</div>



</footer>
      {/* <div className='row text-center text-white bg-dark'>
          <div className='col-sm-3 p-3'>
          <span className='fs-1' ><i className="bi bi-truck"></i></span> 
          <p>FREE SHIPPING</p>
          </div>
          <div className='col-sm-3 p-3'>
          <span className='fs-1' ><i className="bi bi-truck"></i></span> 
          <p>ONLINE PAYMENT</p>
          </div>
          <div className='col-sm-3 p-3'>
          <span className='fs-1' ><i className="bi bi-truck"></i></span> 
          <p>ONLINE SUPPORT</p>
          </div>
          <div className='col-sm-3 p-3'>
          <span className='fs-1' ><i className="bi bi-truck"></i></span> 
          <p>100% SAFE</p>
          </div>
        </div> */}

        
    </>
  )
}

export default Tempfooter
